import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { getThemeTokens } from '../../../theme/tokens';

export const EntityHeaderMeta = ({
  children,
  label,
}: {
  children: ReactNode;
  label: string;
}) => {
  const theme = useTheme();
  const tokens = getThemeTokens(theme);

  return (
    <Box
      component="div"
      sx={{
        display: 'grid',
        gap: 0.625,
        minWidth: { sm: 120, xs: 0 },
      }}
    >
      <Typography
        component="dt"
        sx={{
          color: tokens.textSecondary,
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.06em',
          lineHeight: 1.2,
          textTransform: 'uppercase',
        }}
      >
        {label}
      </Typography>
      <Box
        component="dd"
        sx={{
          alignItems: 'center',
          color: tokens.textPrimary,
          display: 'flex',
          margin: 0,
          minHeight: 24,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
